module.exports = __webpack_public_path__ + "static/media/480.153d3189.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-housekeeping/light/480.png
// module id = 2180
// module chunks = 2